import { createNamespacedHelpers } from 'vuex';
import BaseStore from '@/store';
import actions from './deviations.actions.js';
import getters from './deviations.getters.js';
import mutations from './deviations.mutations.js';
import state from './deviations.state.js';

BaseStore.registerModule('deviations', {
	namespaced: true,
	state: state(),
	actions,
	getters,
	mutations
});
export default BaseStore;

let { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('deviations');

export {
	mapState,
	mapGetters,
	mapMutations,
	mapActions
};
